"use client";
import { lora, loraItalic } from "../../styles/fonts";
import Link from "next/link";

type Summary = {
  offer: string;
  offerDetail: string;
};

const AccordionItem = ({
  title,
  showBorderTop,
  showBorderBottom,
}: {
  title: string;
  index: number;
  showBorderTop: boolean;
  showBorderBottom: boolean;
}) => {
  return (
    <div
      className={`text-olive ${lora.className} w-full ${
        showBorderBottom ? "border-b border-olive" : ""
      } ${showBorderTop ? "border-t border-olive" : ""}`}
    >
      <div className="flex justify-center w-full py-3 px-3">
        <span className="group3:text-base">{title}</span>
      </div>
    </div>
  );
};

const InfoBox = ({ service, route }: { service: Summary[]; route: string }) => {
  const initialItems = service.slice(0, 4);

  return (
    <div className=" w-full flex flex-col bg-white border border-olive flex items-center mx-auto p-6 max-w-xl min-h-[300px] ">
      <div className="w-full">
        {initialItems.map((item: { offer: string }, index: number) => (
          <AccordionItem
            key={index}
            index={index}
            showBorderTop={false}
            showBorderBottom={index !== 3}
            title={item.offer}
          />
        ))}
      </div>

      <Link
        href={`services#${route}`}
        className={`text-lg underline ${loraItalic.className} hover:text-gold mt-4`}
      >
        View More Details
      </Link>
    </div>
  );
};

export default InfoBox;
